/* eslint no-console: 0 */

import Vue from 'vue/dist/vue.esm'

var vueProject;

Vue.config.devtools = true;

document.addEventListener('DOMContentLoaded', () => {
  var projectView = document.getElementById('view-project');

  if (!projectView) {
    return;
  }

  // Vue init
  vueProject = new Vue({
    el: '#view-project',
    data: {
      project: null,
      project_base_profiles_indexed: null,
      project_modulations: null,
      project_modulations_ids: [],
      current_project_modulation_index: null,
      next_project_modulation_index: null,
      current_project_modulation: null,
      current_project_measurement_id: null,
      current_frame_svg_loaded: false,
      current_frame_animation_interval: null,
      current_profile_image_url: null,
      current_profile_code: null,
      current_profile_name: null,
      current_cut_length: null,
      current_profiles_quantity_total_ready: null,
      current_profiles_quantity_total: null,
      current_project_profile_id: null,
      current_discount: null,
      cutting_in_progress: false
    },
    methods: {
      nextProjectModulation() {

        var nextCurrent = this.project_modulations_ids[this.next_project_modulation_index];

        var data = { data: { attributes: { 'current-project-modulation-id': nextCurrent } } };

        fetch('/api/v1/projects/' + this.project.id, {
          headers: { 'Content-Type': 'application/json' },
          method: 'PATCH',
          body: JSON.stringify(data),
        })
        .then(response => response.json())
        .then(response => {

          // Clear right side profile
          vueProject.current_project_profile_id = null;

          // Clear right side frame animation
          vueProject.current_frame_svg_loaded = false;
          clearInterval(vueProject.current_frame_animation_interval);
          $('rect, path').css('fill', 'transparent');
          vueProject.current_frame_animation_interval = null;
        });

      },
      finishProject() {

        fetch('/api/v1/projects/' + this.project.id + '/finish', {
          headers: { 'Content-Type': 'application/json' },
          method: 'PATCH'
        })
        .then(response => response.json())
        .then(response => {

          if (!response.data) {
            console.log('ERROR', response);
          }
        });

      },
      cleanString: function(str) {
        var map = {
          '-' : ' ',
          '-' : '_',
          'a' : 'á|à|ã|â|À|Á|Ã|Â',
          'e' : 'é|è|ê|É|È|Ê',
          'i' : 'í|ì|î|Í|Ì|Î',
          'o' : 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
          'u' : 'ú|ù|û|ü|Ú|Ù|Û|Ü',
          'c' : 'ç|Ç',
          'n' : 'ñ|Ñ'
        };

        str = str.toLowerCase();

        for (var pattern in map) {
          str = str.replace(new RegExp(map[pattern], 'g'), pattern);
        };

        return str;
      }
    }
  })

  // Action cable configuration
  var projectId = projectView.dataset.projectId

  App.projects = App.cable.subscriptions.create({
    channel: 'ProjectsChannel',
    id: projectId
  }, {
    connected: function() {
      new Noty({
        text: 'Conectado exitosamente',
        type: 'success'
      }).show()
    },
    disconnected: function() {
      new Noty({
        text: 'Se ha perdido la conexión',
        type: 'error'
      }).show()
    },
    received: function(project) {
      if (!project) return;
      // Save project
      vueProject.project = project;

      if (project.status == 'completed') {

        vueProject.finishProject();

      } else {

        // Save project modulations (ActionCable payload may use string keys)
        var project_modulations = project.project_modulations || project['project_modulations'];
        if (!project_modulations || !Array.isArray(project_modulations)) {
          console.warn('[Sync] project_modulations missing or not array', project);
          return;
        }
        vueProject.project_modulations = project_modulations;

        // Save project modulation ids
        for (var i = 0; i < project_modulations.length; i++) {
          vueProject.project_modulations_ids.push(project_modulations[i].id);
        }

        // Save current project modulation index
        var current_project_modulation_index = vueProject.project_modulations_ids.indexOf(project.current_project_modulation_id);
        vueProject.current_project_modulation_index = current_project_modulation_index;

        // Save next project modulation index
        if (current_project_modulation_index < (project_modulations.length - 1)) {
          vueProject.next_project_modulation_index = current_project_modulation_index + 1;
        } else {
          vueProject.next_project_modulation_index = 0;
        }

        // Save current project modulation
        var current_project_modulation = project_modulations[vueProject.current_project_modulation_index];
        vueProject.current_project_modulation = current_project_modulation;

        // Save current project base profiles
        if (vueProject.project_base_profiles_indexed === null) {

          var project_base_profiles_indexed = {};
          var project_base_profiles = project.project_base_profiles;
          for (var i = 0; i < project_base_profiles.length; i++) {
            var project_base_profile = project_base_profiles[i];
            project_base_profiles_indexed[project_base_profile.profile_id] = project_base_profile;
          }
          vueProject.project_base_profiles_indexed = project_base_profiles_indexed;
        }
      }

    }
  })
})

// Component - Current Project Modulation Profile Progress
Vue.component('current-project-modulation-profile-progress', {
  props: ['project_modulation',
          'profile_image_url',
          'profile_code',
          'profile_name',
          'profiles_quantity_total_ready',
          'profiles_quantity_total',
          'discount',
          'cut_length'],
  methods: {
    cutCurrentProfile: function() {

      if (!vueProject.cutting_in_progress) {

        vueProject.cutting_in_progress = true;

        new Audio('https://s3.us-east-2.amazonaws.com/perfiletto-public/sound_cut.mp3').play();

        var profilesReady = parseInt(this.profiles_quantity_total_ready) + 1;

        var data = { data: { attributes: { 'profiles-quantity-total-ready': profilesReady } } };

        fetch('/api/v1/project_profiles/' + vueProject.current_project_profile_id, {
          headers: { 'Content-Type': 'application/json' },
          method: 'PATCH',
          body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(response => {

          if (response.data) {

            vueProject.current_profiles_quantity_total_ready = profilesReady;

          } else {
            console.log('ERROR', response);
          }

          vueProject.cutting_in_progress = false;
        });
      }

    }
  },
  mounted: function() {

    this.$nextTick(function () {

      var modulation_frame_svg_img = document.querySelectorAll('#img-project-modulation-image-frame-url');

      // Inject current project modulation frame svg image
      SVGInjector(modulation_frame_svg_img, {}, () => {
        // Mark svg as loaded to don't load again
        vueProject.current_frame_svg_loaded = true;
      });
    })
  },
  template: `
    <div class="card shadow-lg border-0 d-flex h-100 p-3">
      <!-- Right Side Top Section -->
      <div class="flex-even">
        <div class="d-flex h-100">
          <div class="flex-even">
            <div class="d-flex align-items-center justify-content-center flex-column h-100">
              <h6>Modulación</h6>
              <div style="position: relative;">
                <img :src="project_modulation.modulation_image_url" class="modulation-image" />
                <img id="img-project-modulation-image-frame-url" :src="project_modulation.modulation_image_frame_url" style="position:absolute;top:0;left:0;fill: transparent;">
              </div>
            </div>
          </div>
          <div class="flex-even">
            <div class="d-flex align-items-center justify-content-center flex-column h-100">
              <h6>Imagen del perfil</h6>
              <img :src="profile_image_url"  class="profile-image" />
            </div>
          </div>
        </div>
      </div>
      <!-- Right Side Bottom Section -->
      <div class="flex-even">
        <div class="d-flex h-100">
          <div class="flex-even">
            <div class="d-flex align-items-center justify-content-center h-100">
              <div>
                <h3>#{{profile_code}}</h3>
                <h3 class="mb-4">{{profile_name}}</h3>
                <div class="d-flex align-items-center flex-row">
                  <div class="pr-5">
                    Piezas
                    <h1>{{profiles_quantity_total_ready}}/{{profiles_quantity_total}}</h1>
                  </div>
                  <div>
                    Medida a cortar
                    <h1>{{cut_length}} cms</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-even">
            <div class="d-flex flex-row align-items-center justify-content-center h-100">
              <div class="d-flex">
                <div class="text-center">
                  <button class="btn-push" v-on:click="cutCurrentProfile()"></button>
                  Marcar corte
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})

// Component - Project Modulation
Vue.component('project-modulation', {
  props: ['project_modulation'],
  methods: {
    getProgress: function() {
      return ((this.project_modulation.profiles_quantity_total_ready / this.project_modulation.profiles_quantity_total) * 100) + '%';
    }
  },
  template: `
    <div class="card shadow-lg border-0 d-flex h-100">
      <div class="px-3 pt-5">
        <div class="d-flex flex-row align-items-center">
          <div class="flex-even">
            <div class="d-flex align-items-center">
              <img :src="project_modulation.modulation_image_url" height="90px;" class="mr-3" />
              <div class="d-flex flex-column">
                <h6>{{project_modulation.modulation_name}}</h6>
                <h6>{{project_modulation.line_name}}</h6>
                <h6>{{project_modulation.subline_name}}</h6>
              </div>
            </div>
          </div>
          <div class="flex-even">
            <div class="d-flex flex-column align-items-end font-weight-bold">
              <div class="mb-4">
                <span class="pill" v-bind:style="{ 'background-color': project_modulation.line_color }">1</span>
                Cantidad total
              </div>
              <div>
                <div class="progress">
                  <div class="progress-bar" v-bind:style="{ width: getProgress() }"></div>
                  <div class="progress-content d-flex align-items-center justify-content-center">
                    <span>
                      {{project_modulation.profiles_quantity_total_ready}}
                      /
                      {{project_modulation.profiles_quantity_total}}
                    </span>
                  </div>
                </div>
                Total de perfiles
              </div>
            </div>
          </div>
        </div>
        <hr class="my-4" v-bind:style="{ 'background-color': project_modulation.line_color, height: '3px' }" />
      </div>
      <div class="flex-fill d-flex flex-column overflow-auto px-3">
        <project-measurement
          v-for="project_measurement in project_modulation.project_measurements"
          v-bind:key="project_measurement.id"
          v-bind:project_measurement="project_measurement"
        ></project-measurement>
      </div>
    </div>
  `
})

// Component - Project Measurement
Vue.component('project-measurement', {
  props: ['project_measurement'],
  methods: {
    getProgress: function() {
      return ((this.project_measurement.profiles_quantity_total_ready / this.project_measurement.profiles_quantity_total) * 100) + '%';
    },
    toggleShowing: function(showing) {

      var data = { data: { attributes: { showing: showing } } };

      fetch('/api/v1/project_measurements/' + this.project_measurement.id, {
        headers: { 'Content-Type': 'application/json' },
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    }
  },
  template: `
    <div>
      <div class="card mb-3 p-3 font-weight-bold d-flex flex-row align-items-center justify-content-between">
        <div>{{project_measurement.width}} x {{project_measurement.height}} cms</div>
        <div>{{project_measurement.quantity}}</div>
        <div>
          <div class="progress">
            <div class="progress-bar" v-bind:style="{ width: getProgress() }"></div>
            <div class="progress-content d-flex align-items-center justify-content-center">
              <span>
                {{project_measurement.profiles_quantity_total_ready}}
                /
                {{project_measurement.profiles_quantity_total}}
              </span>
            </div>
          </div>
          Perfiles
        </div>
        <button class="btn btn-link font-weight-bold text-wrap" v-on:click="toggleShowing(false)" v-if="project_measurement.showing">Ocultar perfiles</button>
        <button class="btn btn-link font-weight-bold text-wrap" v-on:click="toggleShowing(true)" v-if="!project_measurement.showing">Mostrar perfiles</button>
      </div>
      <project-division
        v-if="project_measurement.showing"
        v-for="project_division in project_measurement.project_divisions"
        v-bind:key="project_division.id"
        v-bind:project_division="project_division"
      ></project-division>
    </div>
  `
})

// Component - Project Division
Vue.component('project-division', {
  props: ['project_division'],
  template: `
    <div>
      <div class="font-weight-bold mb-3 d-flex flex-row align-items-center">
        <div class="flex-grow-1">{{project_division.division_name}}</div>
        <div class="pr-4">Piezas</div>
        <div class="pr-3">Medida a cortar</div>
      </div>
      <project-profile
        v-for="project_profile in project_division.project_profiles"
        v-bind:key="project_profile.id"
        v-bind:project_profile="project_profile"
      ></project-profile>
    </div>
  `
})

// Component - Project Profile
Vue.component('project-profile', {
  props: ['project_profile'],
  data: function () {
    return {
      base_profile: vueProject.project_base_profiles_indexed[this.project_profile.profile_id],
      frame_filled: false,
      frame_selector: this.getFrameSelector(),
      clear_profile_in_progress: false
    }
  },
  methods: {
    getCurrentProjectProfileId() {
      return vueProject.current_project_profile_id;
    },
    getProgress: function() {
      return ((this.project_profile.profiles_quantity_total_ready / this.project_profile.profiles_quantity_total) * 100) + '%';
    },
    showCurrentProfileInRightSide: function() {
      var project_profile = this.project_profile;

      // Current profile information
      vueProject.current_project_measurement_id = this.$parent.project_division.project_measurement_id;
      vueProject.current_profile_image_url = this.base_profile.profile_image_url;
      vueProject.current_profile_code = this.base_profile.profile_code;
      vueProject.current_profile_name = this.base_profile.profile_name;
      vueProject.current_cut_length = project_profile.cut_length;
      vueProject.current_profiles_quantity_total_ready = project_profile.profiles_quantity_total_ready;
      vueProject.current_profiles_quantity_total = project_profile.profiles_quantity_total;
      vueProject.current_project_profile_id = this.project_profile.id;
    },
    isCurrentProjectMeasurement: function() {
      return this.$parent.project_division.project_measurement_id == vueProject.current_project_measurement_id;
    },
    isCurrent: function() {
      return this.project_profile.id == vueProject.current_project_profile_id;
    },
    isFinished: function() {
      return this.project_profile.profiles_quantity_total_ready == this.project_profile.profiles_quantity_total;
    },
    getFrameSelector: function() {

      if (this.project_profile.mapping == null) {
        return;
      }

      var frames = this.project_profile.mapping.split(';');
      var selector = '';

      for (var i = 0; i < frames.length - 1; i++) {
        selector += '#' + frames[i];

        if (i < (frames.length - 2)) {
          selector += ', ';
        }
      }

      return selector;
    },
    clearProfile: function() {

      if (!this.clear_profile_in_progress) {

        this.clear_profile_in_progress = true;

        new Audio('https://s3.us-east-2.amazonaws.com/perfiletto-public/sound_cut.mp3').play();

        var data = { data: { attributes: { 'profiles-quantity-total-ready': 0 } } };

        fetch('/api/v1/project_profiles/' + this.project_profile.id, {
          headers: { 'Content-Type': 'application/json' },
          method: 'PATCH',
          body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(response => {
          this.clear_profile_in_progress = false;
          this.showCurrentProfileInRightSide();
        });
      }


    },
    toggleFrameColor: function() {

      if (this.frame_filled) {
        $(this.frame_selector).css('fill', 'transparent');
      } else {
        $(this.frame_selector).css('fill', '#3497FD');
      }
      this.frame_filled = !this.frame_filled;
    },
    fillFrameStatic: function() {
      if (this.project_profile.profiles_quantity_total_ready == 0) {
        $(this.frame_selector).css('fill', 'transparent');
      } else if (this.isFinished()) {
        $(this.frame_selector).css('fill', '#00ECA3');
      } else {
        $(this.frame_selector).css('fill', '#AED6FE');
      }
    },
    fillFrameDynamic: function() {
      clearInterval(vueProject.current_frame_animation_interval);
      vueProject.current_frame_animation_interval = setInterval(this.toggleFrameColor, 500);
    },
    fillFrame: function() {

      if (!this.isCurrentProjectMeasurement()) {
        return;
      }

      if (this.isFinished()) {

        if (this.isCurrent()) {
          clearInterval(vueProject.current_frame_animation_interval);
          vueProject.current_frame_animation_interval = null;
        }
        $(this.frame_selector).css('fill', '#00ECA3');

      } else {

        // If current profile is being cut, start animation if not just fill colors
        if (this.isCurrent()) {
          console.log(this.frame_selector);
          this.fillFrameDynamic();
        } else {
          this.fillFrameStatic();
        }
      }
    }
  },
  updated: function () {

    this.fillFrame();
  },
  template: `
    <div class="card-progress mb-3"
         v-on:click="showCurrentProfileInRightSide()"
         v-bind:class="{ active: (project_profile.id == getCurrentProjectProfileId()) }">

      <div class="progress-bar" v-bind:style="{ width: getProgress() }"></div>
      <div class="progress-content px-3 py-3 d-flex flex-row align-items-center">
        <div class="pr-3">#{{base_profile.profile_code}}</div>
        <div class="flex-grow-1 text-wrap">{{base_profile.profile_name}}</div>
        <div class="pr-5 font-weight-bold">
          {{project_profile.profiles_quantity_total_ready}}/{{project_profile.profiles_quantity_total}}
        </div>
        <div class="pr-3 font-weight-bold">{{project_profile.cut_length}} cms</div>
        <div class="mx-3" v-if="!isFinished()"></div>
        <div class="check" v-if="isFinished()" v-on:click.stop="clearProfile()"></div>
      </div>

    </div>
  `
})
